module.exports = __webpack_public_path__ + "static/hero-4-dbfb6e58090383a31210b0b2ac5f5b07.png";